/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefPricingInfo } from '../../models/api-def-pricing-info';
import { ApiDefPricingPlanData } from '../../models/api-def-pricing-plan-data';

export interface PricingUpdatePricingPlan$Params {
      body: {

/**
 * Provider-specific data for the pricing plan.
 */
'providerData'?: {
[key: string]: any;
};
'pricingPlanData'?: ApiDefPricingPlanData;
}
}

export function pricingUpdatePricingPlan(http: HttpClient, rootUrl: string, params: PricingUpdatePricingPlan$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefPricingInfo>> {
  const rb = new RequestBuilder(rootUrl, pricingUpdatePricingPlan.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiDefPricingInfo>;
    })
  );
}

pricingUpdatePricingPlan.PATH = '/pricingPlans';
